// Formatea una fecha a DD-MM-YYYY sin dependencias externas (reemplaza moment).
export const formatFecha = (fecha) => {
  if (!fecha) return "-"
  const d = new Date(fecha)
  if (Number.isNaN(d.getTime())) return String(fecha)
  const dd = String(d.getDate()).padStart(2, "0")
  const mm = String(d.getMonth() + 1).padStart(2, "0")
  const yyyy = d.getFullYear()
  return `${dd}-${mm}-${yyyy}`
}
